import { useState, useEffect } from "react";
import {
  Box,
  TextField,
  FormControl,
  FormControlLabel,
  Grid,
  Button,
  Paper,
  Checkbox,
  Typography,
  FormLabel,
  Tooltip,
  InputAdornment,
} from "@mui/material";
import Note from "../../Images/alert.png";
import { createStyles, makeStyles } from "@mui/styles";
import {
  AddEmpIDContractualHelper,
  AddEmpIDHelper,
  GetEmpIDContractualHelper,
  GetEmpIDHelper,
  UpdateEmpIDContractualHelper,
  UpdateEmpIDHelper,
} from "../../../Ancillary/CompanyDetails/helper/CompanyDetailsHelper";
import Popup from "../../../Base/views/Popup";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const EmployeeID = ({ validateOnly, setOpenConfirmation }) => {
  const useStyles = makeStyles((theme) =>
    createStyles({
      Paper: {
        boxShadow:
          theme.palette.mode === "dark"
            ? "rgb(0 0 0 / 20%) 0px 0px 2px 0px, rgb(0 0 0 / 12%) 0px 12px 24px -4px"
            : "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
        padding: "20px",
        borderRadius: "10px",
        backgroundColor: "#f3edfd",
      },
      previewBox: {
        backgroundColor: "#ffffff",
        padding: "15px",
        borderRadius: "8px",
        border: "1px solid #e0e0e0",
      },
    }),
  );

  const classes = useStyles();

  const initialValue = {
    prefix: "",
    suffix: "",
    emp_code: "4",
    yoj: true,
    configure_employee_pk: null,
  };

  const initialContractualValue = {
    prefix: "",
    suffix: "",
    emp_code: "4",
    yoj: true,
    contractual_employee_no_configure_pk: null,
  };

  const [inputData, setInputData] = useState(initialValue);
  const [inputContData, setInputContData] = useState(initialContractualValue);
  const [errors, setErrors] = useState({});
  const [contractualErrors, setContractualErrors] = useState({});
  const [show, setShow] = useState(false);
  const [updateshow, setUpdateShow] = useState(false);
  const [showContractual, setShowContractual] = useState(false);
  const [showContractualUpdate, setShowContractualUpdate] = useState(false);

  useEffect(() => {
    GetEmpIDHelper()
      .then((res) => {
        const existing = res?.data?.data?.[0];
        if (existing) {
          setInputData({ ...initialValue, ...existing });
        }
      })
      .catch((err) => {
        console.log(err);
      });

    GetEmpIDContractualHelper()
      .then((res) => {
        const existing = res?.data?.data?.[0];
        if (existing) {
          setInputContData({ ...initialContractualValue, ...existing });
        }
      })
      .catch((err) => {
        console.log(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validate = (fieldValues, isContractual = false) => {
    const errorTarget = isContractual ? contractualErrors : errors;
    const setErrorTarget = isContractual ? setContractualErrors : setErrors;

    let temp = { ...errorTarget };

    if ("emp_code" in fieldValues) {
      temp.emp_code =
        fieldValues.emp_code === null || fieldValues.emp_code === ""
          ? "Emp code is required"
          : "";
    }

    setErrorTarget({ ...temp });

    return Object.values(temp).every((x) => x === "");
  };

  const generateSampleOutput = (type = "full_time") => {
    const currentYear = new Date().getFullYear();
    const configData = type === "contractual" ? inputContData : inputData;
    const empCodeLength = parseInt(configData?.emp_code, 10) || 4;
    const empNumber = "1".padStart(empCodeLength, "0");

    let output = "";
    if (configData?.prefix) {
      output += configData.prefix;
    }
    output += empNumber;
    if (configData?.yoj) {
      output += currentYear;
    }
    if (configData?.suffix) {
      output += configData.suffix;
    }

    return output;
  };

  const handleInput = (event, type = "full_time") => {
    const { name, value, checked } = event?.target || {};

    if (!name) return;

    const updateState = type === "contractual" ? setInputContData : setInputData;
    const currentState = type === "contractual" ? inputContData : inputData;

    if (["yoj"].includes(name)) {
      updateState({
        ...currentState,
        [name]: checked,
      });
      return;
    }

    if (["emp_code"].includes(name)) {
      if (value === "" || /^[3-6]$/.test(value)) {
        updateState({ ...currentState, emp_code: value });
      }
      return;
    }

    updateState({
      ...currentState,
      [name]: value,
    });
  };

  const handleValidate = (type = "full_time") => {
    const configData = type === "contractual" ? inputContData : inputData;
    const isValid = validate(configData, type === "contractual");

    if (!isValid) return;

    if (type === "contractual") {
      if (inputContData?.contractual_employee_no_configure_pk) {
        setShowContractualUpdate(true);
      } else {
        setShowContractual(true);
      }
      return;
    }

    if (inputData?.configure_employee_pk) {
      setUpdateShow(true);
    } else {
      setShow(true);
    }
  };

  const handleAdd = async (type = "full_time") => {
    const configData = type === "contractual" ? inputContData : inputData;

    if (type === "contractual") {
      setShowContractual(false);
      AddEmpIDContractualHelper({ ...configData })
        .then((res) => {
          setInputContData({ ...initialContractualValue, ...res?.data?.data?.[0] });
          if (validateOnly) {
            setOpenConfirmation(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
      return;
    }

    setShow(false);
    AddEmpIDHelper({ ...configData })
      .then((res) => {
        setInputData({ ...initialValue, ...res?.data?.data?.[0] });
        if (validateOnly) {
          setOpenConfirmation(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleUpdate = async (type = "full_time") => {
    const configData = type === "contractual" ? inputContData : inputData;

    if (type === "contractual") {
      setShowContractualUpdate(false);
      UpdateEmpIDContractualHelper({ ...configData })
        .then((res) => {
          if (res?.data?.statuscode === 200) {
            setInputContData({ ...initialContractualValue, ...res?.data?.data?.[0] });
          }
        })
        
      return;
    }

    setUpdateShow(false);
    UpdateEmpIDHelper({ ...configData })
      .then((res) => {
        if (res?.data?.statuscode === 200) {
          setInputData({ ...initialValue, ...res?.data?.data?.[0] });
        }
      })
      
  };

  return (
    <Box>
      <Popup
        maxWidth="xs"
        openPopup={show}
        setOpenPopup={setShow}
        title="Note!"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ mt: 1, mb: 1, textAlign: "center !important" }}>
            <img src={Note} width={"25%"} alt="note_img" />
          </Box>
          <FormControl>
            <FormLabel id="gender-label">
              <Typography variant="h5">
                All new onboarding employees will follow the same pattern.
              </Typography>
            </FormLabel>
          </FormControl>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingTop: "10px",
          }}
        >
          <Button
            onClick={() => setShow(false)}
            variant="contained"
            type="submit"
            className="mpl-primary-btn profile-btn"
            size="small"
            sx={{ margin: "10px" }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleAdd("full_time")}
            variant="contained"
            type="submit"
            className="mpl-primary-btn profile-btn"
            size="small"
            sx={{ margin: "10px" }}
          >
            Ok
          </Button>
        </Box>
      </Popup>

      <Popup
        maxWidth="xs"
        openPopup={updateshow}
        setOpenPopup={setUpdateShow}
        title="Note!"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ mt: 1, mb: 1, textAlign: "center !important" }}>
            <img src={Note} width={"25%"} alt="note_img" />
          </Box>
          <FormControl>
            <FormLabel id="gender-label">
              <Typography variant="h5">
                The NewEmployee IDs will be generated in the new format.
              </Typography>
            </FormLabel>
          </FormControl>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingTop: "10px",
          }}
        >
          <Button
            onClick={() => setUpdateShow(false)}
            variant="contained"
            type="submit"
            className="mpl-primary-btn profile-btn"
            size="small"
            sx={{ margin: "10px" }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleUpdate("full_time")}
            variant="contained"
            type="submit"
            className="mpl-primary-btn profile-btn"
            size="small"
            sx={{ margin: "10px" }}
          >
            Ok
          </Button>
        </Box>
      </Popup>

      <Popup
        maxWidth="xs"
        openPopup={showContractual}
        setOpenPopup={setShowContractual}
        title="Note!"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ mt: 1, mb: 1, textAlign: "center !important" }}>
            <img src={Note} width={"25%"} alt="note_img" />
          </Box>
          <FormControl>
            <FormLabel id="gender-label">
              <Typography variant="h5">
                All new contractual employees will follow the same pattern.
              </Typography>
            </FormLabel>
          </FormControl>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingTop: "10px",
          }}
        >
          <Button
            onClick={() => setShowContractual(false)}
            variant="contained"
            type="submit"
            className="mpl-primary-btn profile-btn"
            size="small"
            sx={{ margin: "10px" }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleAdd("contractual")}
            variant="contained"
            type="submit"
            className="mpl-primary-btn profile-btn"
            size="small"
            sx={{ margin: "10px" }}
          >
            Ok
          </Button>
        </Box>
      </Popup>

      <Popup
        maxWidth="xs"
        openPopup={showContractualUpdate}
        setOpenPopup={setShowContractualUpdate}
        title="Note!"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ mt: 1, mb: 1, textAlign: "center !important" }}>
            <img src={Note} width={"25%"} alt="note_img" />
          </Box>
          <FormControl>
            <FormLabel id="gender-label">
              <Typography variant="h5">
                The contractual employee IDs will be generated in the new format.
              </Typography>
            </FormLabel>
          </FormControl>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingTop: "10px",
          }}
        >
          <Button
            onClick={() => setShowContractualUpdate(false)}
            variant="contained"
            type="submit"
            className="mpl-primary-btn profile-btn"
            size="small"
            sx={{ margin: "10px" }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleUpdate("contractual")}
            variant="contained"
            type="submit"
            className="mpl-primary-btn profile-btn"
            size="small"
            sx={{ margin: "10px" }}
          >
            Ok
          </Button>
        </Box>
      </Popup>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Paper
              className={classes.Paper}
              sx={{ borderRadius: "16px" }}
            >
              <Typography
                variant="subtitle1"
                color="inherit"
                sx={{
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  mb: 2,
                  gap: 0.5,
                }}
              >
                Full-Time Employees
                <Tooltip
                  title={"Used to configure the Employee ID format for full-time employees."}
                  arrow
                  placement="top"
                >
                  <InfoOutlinedIcon
                    color="action"
                    sx={{
                      cursor: "pointer",
                      fontSize: 16,
                    }}
                  />
                </Tooltip>
              </Typography>

              <Grid container spacing={1.5}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    type="text"
                    label="Prefix"
                    fullWidth
                    name="prefix"
                    onChange={(event) => handleInput(event, "full_time")}
                    value={inputData?.prefix || ""}
                    size="small"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    type="text"
                    label="Suffix"
                    fullWidth
                    name="suffix"
                    onChange={(event) => handleInput(event, "full_time")}
                    value={inputData?.suffix || ""}
                    size="small"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <TextField
                      required
                      type="text"
                      label="Number of Digits in Emp code"
                      fullWidth
                      name="emp_code"
                      onChange={(event) => handleInput(event, "full_time")}
                      inputProps={{ maxLength: 6 }}
                      value={inputData?.emp_code}
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip
                              title="Enter the number of digits for employee codes (minimum 3, maximum 6). E.g., '4' will generate codes like 0001, 0002."
                              arrow
                              placement="top"
                            >
                              <InfoOutlinedIcon
                                sx={{
                                  fontSize: 20,
                                  cursor: "pointer",
                                  color: "text.secondary",
                                }}
                              />
                            </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                      {...(errors.emp_code && {
                        error: true,
                        helperText: errors.emp_code,
                      })}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <FormControl>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="yoj"
                          checked={inputData?.yoj || false}
                          onChange={(event) => handleInput(event, "full_time")}
                        />
                      }
                      label="Year of Joining"
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "space-between", }}>
                  <Box
                    className={classes.previewBox}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      height: "38px",
                      flex: 1
                    }}
                  >
                    <Typography variant="subtitle2" sx={{ color: "#666", mr: 1 }}>
                      Sample:
                    </Typography>

                    <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                      {generateSampleOutput("full_time")}
                    </Typography>
                  </Box>
                  <Box>
                    {inputData?.configure_employee_pk ? (
                      <Button
                        type="submit"
                        variant="contained"
                        size="medium"
                        onClick={() => handleValidate("full_time")}
                        className="mpl-primary-btn"
                        sx={{ minWidth: "80px" }}
                      >
                        Update
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        variant="outlined"
                        size="medium"
                        onClick={() => handleValidate("full_time")}
                        className="mpl-primary-btn"
                        sx={{ minWidth: "80px" }}
                      >
                        Add
                      </Button>
                    )}
                  </Box>
                </Grid>
              </Grid>

            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper
              className={classes.Paper}
              sx={{ borderRadius: "16px" }}
            >
              <Typography
                variant="subtitle1"
                color="inherit"
                sx={{
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  mb: 2,
                  gap: 0.5,
                }}
              >
                Contractual Employees
                <Tooltip
                  title={"Used to configure the Employee ID format for contractual employees."}
                  arrow
                  placement="top"
                >
                  <InfoOutlinedIcon
                    color="action"
                    sx={{
                      cursor: "pointer",
                      fontSize: 16,
                    }}
                  />
                </Tooltip>
              </Typography>

              <Grid container spacing={1.5}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    type="text"
                    label="Prefix"
                    fullWidth
                    name="prefix"
                    onChange={(event) => handleInput(event, "contractual")}
                    value={inputContData?.prefix || ""}
                    size="small"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    type="text"
                    label="Suffix"
                    fullWidth
                    name="suffix"
                    onChange={(event) => handleInput(event, "contractual")}
                    value={inputContData?.suffix || ""}
                    size="small"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <TextField
                      required
                      type="text"
                      label="Number of Digits in Emp code"
                      fullWidth
                      name="emp_code"
                      onChange={(event) => handleInput(event, "contractual")}
                      inputProps={{ maxLength: 6 }}
                      value={inputContData?.emp_code}
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip
                              title="Enter the number of digits for employee codes (minimum 3, maximum 6). E.g., '4' will generate codes like 0001, 0002."
                              arrow
                              placement="top"
                            >
                              <InfoOutlinedIcon
                                sx={{
                                  fontSize: 20,
                                  cursor: "pointer",
                                  color: "text.secondary",
                                }}
                              />
                            </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                      {...(contractualErrors.emp_code && {
                        error: true,
                        helperText: contractualErrors.emp_code,
                      })}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <FormControl>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="yoj"
                          checked={inputContData?.yoj || false}
                          onChange={(event) => handleInput(event, "contractual")}
                        />
                      }
                      label="Year of Joining"
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "space-between", }}>
                  <Box
                    className={classes.previewBox}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      height: "38px",
                      flex: 1
                    }}
                  >
                    <Typography variant="subtitle2" sx={{ color: "#666", mr: 1 }}>
                      Sample:
                    </Typography>

                    <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                      {generateSampleOutput("contractual")}
                    </Typography>
                  </Box>
                  <Box>
                    {inputContData?.contractual_employee_no_configure_pk ? (
                      <Button
                        type="submit"
                        variant="contained"
                        size="medium"
                        onClick={() => handleValidate("contractual")}
                        className="mpl-primary-btn"
                        sx={{ minWidth: "80px" }}
                      >
                        Update
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        variant="outlined"
                        size="medium"
                        onClick={() => handleValidate("contractual")}
                        className="mpl-primary-btn"
                        sx={{ minWidth: "80px" }}
                      >
                        Add
                      </Button>
                    )}
                  </Box>

                </Grid>
              </Grid>

            </Paper>
          </Grid>
        </Grid>
    </Box>
  );
};

export default EmployeeID;
